import Vue from 'vue/dist/vue.js'
import VueFormat from './vue-format.vue'

Vue.component('vue-format', VueFormat);
